// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__34ggG","dragIcon":"Choice_dragIcon__2rfso","left":"Choice_left__1KOI7","input":"Choice_input__2fw98"};